<template>
    <div ref="footer" />
</template>

<script>
import axios from 'axios';
export default {
    async created() {
      const res = await axios.get(process.env.FOOTER_ENDPOINT, { withCredentials: true });
      this.$refs.footer.innerHTML = res.data;
    }
}
</script>

<style>
html, body {
    height: 100%;
}
</style>

<style lang="scss" scoped>
div {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background-color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/Nav/Footer.vue